import { useEffect } from "react";

import useTranslator from "@/shared/translate/translator";
import InitView from "@/refund/views/init";
import { useGetUserConfiguration } from "@/refund/use-cases";
import { Constants as routerConstants } from "@/refund/routes";
import { useNavigate } from "react-router-dom";
import { Flex, Spin } from "@payping/web-components";

const Init: React.FC = () => {
  const { t } = useTranslator("refund.init");
  const getUserConfiguration = useGetUserConfiguration();
  const navigate = useNavigate();

  useEffect(() => {
    if (getUserConfiguration.isLoading) {
      return;
    }
    if (getUserConfiguration.isSuccess) navigate(routerConstants.wallet.url);
  }, [getUserConfiguration, navigate]);

  useEffect(() => {
    document.title = t("pageTitle");
  }, [t]);

  if (getUserConfiguration.isLoading) {
    return (
      <Flex className="tw-h-full tw-w-full" justify="center" align="center">
        <Spin />
      </Flex>
    );
  }
  return <InitView />;
};
export default Init;
